import React, { useState } from 'react';
import { Redirect, useHistory, useLocation } from 'react-router-dom';
import { Formik } from 'formik';
import { Container, Row, Col, Form, Button, Alert } from 'react-bootstrap';
import { getAdminSession, loginAdmin } from './adminAuth';

export default function AdminLogin() {
  const history = useHistory();
  const location = useLocation();
  const [error, setError] = useState(null);
  const [waking, setWaking] = useState(false);

  const destination = (location.state && location.state.from) || { pathname: '/admin' };

  if (getAdminSession()) {
    return <Redirect to={destination} />;
  }

  const handleLogin = async (values, { setSubmitting }) => {
    setError(null);
    try {
      await loginAdmin(values.username.trim(), values.password, { onWaking: () => setWaking(true) });
      history.replace(destination);
    } catch (err) {
      setWaking(false);
      setError(err.message);
      setSubmitting(false);
    }
  };

  return (
    <Container className="mt-5">
      <Row className="justify-content-center">
        <Col xs={12} sm={8} md={5} lg={4}>
          <h2 className="mb-4">Admin sign in</h2>
          {error && <Alert variant="danger">{error}</Alert>}
          <Formik initialValues={{ username: '', password: '' }} onSubmit={handleLogin}>
            {({ values, handleChange, handleSubmit, isSubmitting }) => (
              <Form onSubmit={handleSubmit}>
                <Form.Group controlId="adminUsername">
                  <Form.Label>Username</Form.Label>
                  <Form.Control
                    name="username"
                    autoComplete="username"
                    value={values.username}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
                <Form.Group controlId="adminPassword">
                  <Form.Label>Password</Form.Label>
                  <Form.Control
                    type="password"
                    name="password"
                    autoComplete="current-password"
                    value={values.password}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
                <Button type="submit" variant="primary" disabled={isSubmitting} block>
                  {isSubmitting ? (waking ? 'Waking the database...' : 'Signing in...') : 'Sign in'}
                </Button>
              </Form>
            )}
          </Formik>
        </Col>
      </Row>
    </Container>
  );
}
